import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css'
import axios from 'axios'
import Constant from '../../../Constant'

class StoreBlockDateList extends React.Component {
    state = {
        dates: [],
        isloading: false,
        storeId: this.props.match.params.storeId,
    }

    formatBookingDate = (value) => {
        if (!value) return ''
        const d = new Date(value)
        if (Number.isNaN(d.getTime())) return value

        return new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        }).format(d)
    }

    componentDidMount() {
        this.getBlockDates()
    }

    getBlockDates = async () => {
        var that = this
        this.setState({ isloading: true })
        var storeId = this.props.match.params.storeId
        await axios
            .get(Constant.getAPI() + `/store/get-store-block-dates/${storeId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                    country_short_name: `${localStorage.getItem('countryShortName')}`,
                },
            })
            .then((res) => {
                if (res.data.success) {
                    this.setState({ isloading: false })
                    that.setState({
                        dates: res.data.data,
                    })
                }
            })
            .catch((err) => {
                this.setState({ isloading: false })
                if (err?.response?.status === 401) {
                    Constant.getAuthLogout()
                } else {
                    Swal.fire({
                        title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                        icon: 'error',
                        text: '',
                        type: 'error',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ok',
                    })
                }
            })
    }

    deleteBlockDate = (id) => {
        var token = `Bearer ${localStorage.getItem('loged_In_auth')}`

        axios
            .delete(Constant.getAPI() + `/store/delete-store-block-date/${id}`, {
                headers: { Authorization: token, country_short_name: `${localStorage.getItem('countryShortName')}` },
            })
            .then(() => {
                Swal.fire({
                    title: 'Block Date Deleted Successfully!',
                    icon: 'success',
                    text: '',
                    type: 'success',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok',
                })
                this.getBlockDates()
            })
            .catch((err) => {
                if (err?.response?.status === 401) {
                    Constant.getAuthLogout()
                } else {
                    Swal.fire({
                        title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                        icon: 'error',
                        text: '',
                        type: 'error',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ok',
                    })
                }
            })
    }

    render() {
        const columns = [
            {
                name: 'id',
                label: 'id',
                options: {
                    filter: true,
                    sort: true,
                    display: false,
                },
            },
            {
                name: 'date',
                label: `Booking Date`,
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => this.formatBookingDate(value),
                },
            },
            {
                name: 'id',
                label: 'Actions',
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (id) => {
                        return (
                            <div>
                                <span
                                    onClick={this.deleteBlockDate.bind(this, id)}
                                    className="m-r-15 text-muted"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title=""
                                    data-original-title="Delete"
                                >
                                    <i className="f-20 icofont icofont-delete-alt text-danger"></i>{" "}
                                </span>
                            </div>
                        )
                    },
                },
            },
        ]
        const options = {
            filterType: true,
            viewColumns: false,
            print: false,
            download: false,
            selectableRows: 'none',
            textLabels: {
                body: {
                    noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Block Dates Found',
                    toolTip: 'Sort',
                    columnHeaderTooltip: (column) => `Sort for ${column.label}`,
                },
            },
        }

        return (
            <div className="pcoded-inner-content">
                <div className="main-body">
                    <div className="page-wrapper">
                        <div className="page-header">
                            <div className="row align-items-end">
                                <div className="col-lg-8">
                                    <div className="page-header-title">
                                        <div className="d-inline">
                                            <h4>Store Block Date List</h4>
                                        </div>
                                    </div>
                                    <Link
                                        to={`/store-details/${this.props.match.params.storeId}/store-block-date-add`}
                                        className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                                        data-modal="modal-13"
                                    >
                                        {' '}
                                        <i className="icofont icofont-plus m-r-5"></i>
                                        Store Block Date Add
                                    </Link>
                                </div>
                                <div className="col-lg-4">
                                    <div className="page-header-breadcrumb">
                                        <ul className="breadcrumb-title">
                                            <li className="breadcrumb-item">
                                                <Link to="/">
                                                    <i className="feather icon-home"></i>{' '}
                                                </Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <Link to={`/store-details`}>
                                                    Store List
                                                </Link>
                                            </li>
                                            <li className="breadcrumb-item active">Store Block Date List</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="page-body">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card">
                                        <div className="card-block">
                                            <div className="dt-responsive table-responsive">
                                                {this.state?.isloading ? (
                                                    'loading...'
                                                ) : (
                                                    <MUIDataTable
                                                        title={`Store Block Date List`}
                                                        className="table-responsive"
                                                        data={this.state.dates}
                                                        columns={columns}
                                                        options={options}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default StoreBlockDateList
